import type { Currency, CurrencyConversion, ExchangeRateProvider, SupportedCurrency } from "../types";
import { api } from "./core";

export const currenciesApi = {
  currencies: (groupId: string) => api<Currency[]>("/currencies", { groupId }),
  supportedCurrencies: () => api<SupportedCurrency[]>("/supported-currencies"),
  createCurrency: (groupId: string, code: string) =>
    api<Currency>("/currencies", { method: "POST", body: JSON.stringify({ code }), groupId }),
  deleteCurrency: (groupId: string, code: string) =>
    api<void>(`/currencies/${encodeURIComponent(code)}`, { method: "DELETE", groupId }),
  exchangeRateProvider: () => api<ExchangeRateProvider>("/exchange-rate-provider"),
  convertCurrency: (groupId: string, options: { amount: string; base: string; quote: string; date: string }) => {
    const params = new URLSearchParams();
    params.set("amount", options.amount);
    params.set("base", options.base);
    params.set("quote", options.quote);
    params.set("date", options.date);
    return api<CurrencyConversion>(`/exchange-rates/convert?${params.toString()}`, { groupId });
  },
};
